import { Component, EventEmitter, Input, Output } from '@angular/core'

import { CloseActionProps, closeActionStyles } from '@kite_aerolab/shared/components';


@Component({
  selector: 'kite-close-action',
  template: `
  <div [ngClass]="closeActionStyles">
    <kite-button
      size="sm"
      variant="tertiary"
      aria-label="Close button"
      (click)="onClick.emit($event)"
      icon="close"
    >
    </kite-button>
  </div>
  `
})
export class CloseActionComponent {

  /**
   * CSS del componente
   */
   @Input() css: CloseActionProps['css'];

  /**
   * onDark
   */
  @Input() onDark: CloseActionProps['onDark'];

  /**
   * Click handler
   */
   @Output() onClick: EventEmitter<any> = new EventEmitter();


  public get closeActionStyles(): string[] {
    return [
      closeActionStyles({
        css: this.css,
        onDark: this.onDark,
      }).className,
    ];
  }
}